// extracted by mini-css-extract-plugin
export default {"cardContent":"Details_cardContent__PvKCi","photo":"Details_photo__X3UQC"};